import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface DashboardHeaderProps {
  propertyName: string;
  timePeriod: string;
  groupBy: string;
  onTimePeriodChange: (value: string) => void;
  onGroupByChange: (value: string) => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  propertyName,
  timePeriod,
  groupBy,
  onTimePeriodChange,
  onGroupByChange,
}) => {
  // Time period options

  const days3Months: string = '90';
  const days6Months: string = '180';

  const timePeriods = [
    { value: '1', label: 'Last 24 Hours' },
    { value: '7', label: 'Last 7 Days' },
    { value: '30', label: 'Last 30 Days' },
    { value: days3Months, label: 'Last 3 Months' },
    { value: days6Months, label: 'Last 6 Months' },
  ];

  // Group by options
  const groupByOptions = [
    { value: 'day', label: 'By Day' },
    { value: 'week', label: 'By Week' },
    { value: 'month', label: 'By Month' },
  ];

  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground">
          Analytics for {propertyName || 'Your Website'}
        </p>
      </div>
      
      {/* Filters */}
      <div className="flex gap-2">
        <Select value={timePeriod} onValueChange={onTimePeriodChange}>
          <SelectTrigger className="w-48">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {timePeriods.map((period) => (
              <SelectItem key={period.value} value={period.value}>
                {period.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        
        <Select value={groupBy} onValueChange={onGroupByChange}>
          <SelectTrigger className="w-32">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {groupByOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default DashboardHeader;
